// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"506":"28acdc9a","648":"042c9cb4","876":"1d5f4894"}[chunkId] + ".js";
};